import axios from "axios"
import { API_PATH } from "../libs/config"
import { toast } from "react-toastify"
import { STORAGE } from "./storage"
import { USER_TYPE } from "../libs/config"
import { LANGUAGE_LOCALE } from "../libs/config"

const instance = axios.create()

instance.interceptors.request.use(
  request => {
    // Always set language and Zrok header
    const locale = STORAGE.getLocale() || LANGUAGE_LOCALE["default_lang"]
    request.headers["Accept-Language"] = locale
    request.headers["ngrok-skip-browser-warning"] = "true"

    // Send browser timezone so backend can localize times correctly
    try {
      request.headers["X-Timezone"] = Intl.DateTimeFormat().resolvedOptions().timeZone
    } catch (e) { /* ignore */ }

    // Add Authorization token if available and not already set
    const token = STORAGE.getItem("noahCares")?.token
    const byPassUrl = [
      API_PATH.LOGIN,
      API_PATH.PRIVACY_POLICY,
      API_PATH.TERMS_AND_CONDITIONS,
      API_PATH.RESET_PASSWORD,
      API_PATH.NEW_PASSWORD
    ]

    if (!byPassUrl.includes(request.url) && token && !request.headers.Authorization) {
      request.headers.Authorization = `Token ${token}`
    }

    return request
  },
  error => Promise.reject(error)
)

instance.interceptors.response.use(
  response => {
    const url = response?.config?.url
    const data = response?.data?.data
    const user = data?.user

    if (url === API_PATH.LOGIN) {
      if (user?.is_two_factor_enabled === false) {
        const token = data?.token
        if ([1, 2, 3, 4].includes(user.user_type)) {
          STORAGE.setItem("noahCares", { token, user })
        } else {
          STORAGE.clear()
          toast.error(`User with role ${USER_TYPE[user.user_type]} have no rights to login`)
        }
      } else if (user?.is_two_factor_enabled === true) {
        const two_factor_identifier = data?.two_factor_identifier
        STORAGE.setItem("noahCares", { two_factor_identifier })
      }
    } else if (url.includes(API_PATH.VERIFY_OTP) && url.includes("verify_otp")) {
      const token = data?.token
      if ([1, 2, 3, 4].includes(user.user_type)) {
        STORAGE.setItem("noahCares", { token, user })
      } else {
        STORAGE.clear()
        toast.error(`User with role ${USER_TYPE[user.user_type]} have no rights to login`)
      }
    }

    return response
  },
  error => {
    if (!error?.config?.skipErrorToast) {
      toast.error(error?.response?.data?.message || error.message)
    }
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      location.replace("/login")
    }
    return Promise.reject(error)
  }
)

export default instance
